import { connect } from 'react-redux'
import MachineReport from '../../components/MachineReport/MachineReport'
import { getAllLicenses, initializeLicenseWizard, startLicenseFromRow } from '../../actions/index'

const mapStateToProps = state => {
    return {
        data: state.license.allLicenses,
        isAdmin: state.auth.adminInfo === 1
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllLicenses: () => dispatch(getAllLicenses()),
        initLicenseWizard: () => dispatch(initializeLicenseWizard()),
        startLicenseFromRow: (row) => dispatch(startLicenseFromRow(row))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MachineReport)
